<template>
    <div>
      <p class="help" v-if="absence.length === 0">{{$t("absence.noApp")}}</p>
      <table v-else class="table">
        <thead>
          <tr>
            <th>{{$t("absence.absence")}}</th>
            <th>{{$t("absence.from")}}</th>
            <th>{{$t("absence.to")}}</th>
            <th>{{$t("absence.time")}}</th>
            <th>
              Godkend
              <!-- <span class="field is-grouped" v-if="regs.length > 0">
                  <p class="control">
                    <a @click="approveAllRegistrations()" class="button is-small is-primary">Godkend alle</a>
                  </p>
                <p class="control">
                  <a @click="rejectAllRegistrations()" class="button is-small is-danger">Afvis alle</a>
                </p>
              </span> -->
            </th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="abs in absence" v-if="!abs.isApproved" v-bind:key="abs['.key']">
            <td>{{abs.absence}}<span v-if="abs.absenceMeasure"> ({{abs.absenceMeasure}})</span></td>
            <td>{{ moment(abs.fromDate) }}</td>
            <td>{{ moment(abs.toDate) }}</td>
            <td>{{abs.time}}</td>
            <td>
              <div class="field is-grouped">
                <p class="control">
                 <a @click="approveAbsence(abs)" class="button is-small is-primary">{{$t("input.approve")}}</a>
                </p>
                <p class="control">
                  <a @click="rejectAbsence(abs)" class="button is-small is-danger">{{$t('input.reject')}}</a>
                </p>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
</template>

<script>
import firebase from '@/firebase'
import moment from 'moment'
import _ from 'lodash'

export default {
  name: 'AbsenceRegistrations',
  props: {
    userId: String
  },
  data: function() {
    return {
      monthArray: [],
    }
  },
  firebase: function() { 
    const tenantid = JSON.parse(localStorage.getItem('profile')).tenantid;
    const userid = JSON.parse(localStorage.getItem('profile')).user_id;
    return {
        regs: {
            source: firebase.database().ref('/organisations/' + tenantid + '/registrations/' + this.userId).orderByChild('sentForApproval').equalTo(true),
        },
        absence: {
            source: firebase.database().ref('/organisations/' + tenantid + '/registrationsAbsence/' + this.userId).orderByChild('sentForApproval').equalTo(true),
        },
        regsERP: {
            source: firebase.database().ref('/organisations/' + tenantid + '/ERPrequests').limitToFirst(1),
        },
        allProjects: {
            source: firebase.database().ref('/organisations/' + tenantid + '/JobList'),
        },
        allProjectLines: {
            source: firebase.database().ref('/organisations/' + tenantid + '/JobTaskLines').orderByChild('favorite'),
        },
        orgUsers: {
            source: firebase.database().ref('/organisations/' + tenantid + '/users').orderByChild('adminCanEdit/active').equalTo(true),
            asObject: false,
        },
        orgResources: {
            source: firebase.database().ref('/organisations/' + tenantid + '/ResourceList').orderByChild('type').equalTo('Person'),
            asObject: false,
        },
    }
  },
  computed: {
    regsGroupedMonthly() {
      return _.groupBy(this.absence, function(o) {
                  return moment(o.date).month();
            })
    },
  },
  methods: {
    sumMonthlyTime(month) {
      const self = this;
      const filteredRegs = _.filter(this.regs, function(o) {
        if(moment(o.date).month() == month && o.isApproved === false) {
          return o;
        }
      })
      return _.sumBy(filteredRegs, 'time')
    },
    filterApprovedMonth(regs) {
      const containsOnlyApproved = _.flatMap(regs, 'isApproved')
      return _.includes(containsOnlyApproved, false)
    },
    showMonth(index) {
      if(_.includes(this.monthArray, index)) {
        return true;
      } else {
        return false;
      }
    },
    expandMonth(index) {
      if(_.includes(this.monthArray, index)) {
        for (var i=this.monthArray.length-1; i>=0; i--) {
            if (this.monthArray[i] === index) {
                this.monthArray.splice(i, 1);
            }
        }
      }  else {
        this.monthArray.push(index);
      }
    },
    returnMonthNo(date) {
      return moment(date).month()
    },
    returnMonthName(month) {
      moment.locale(this.$i18n.locale)
      return moment().month(month).format('MMMM')
    },
    rejectMonthlyRegistrations(month) {
      const self = this;
      const filteredRegs = _.filter(this.regs, function(o) {
        if(moment(o.date).month() == month) {
          return o;
        }
      })
      _.forEachRight(filteredRegs, function(reg) {
        self.rejectRegistration(reg['.key'])
      }) 
    },
    approveMonthlyRegistrations(month) {
      const self = this;
      const filteredRegs = _.filter(this.regs, function(o) {
        if(moment(o.date).month() == month) {
          return o;
        }
      })
      _.forEach(filteredRegs, function(reg) {self.approveRegistration(reg)})
    },
    approveAllRegistrations() {
      const self = this;
      _.forEach(this.regs, function(reg) {self.approveRegistration(reg)})
    },
    rejectAllRegistrations() {
      const self = this;
      _.forEachRight(this.regs, function(reg) {
        self.rejectRegistration(reg['.key'])
      })
    },
    returnProjectDescription: function(projectNo) {
      var project = _.find(this.allProjects, { 'no': projectNo });
      if (project) {
        return project.description;
      } else {
        return;
      }
    },
    returnProjectLineDescription: function(projectNo, lineNo) {
      var projectLine = _.find(this.allProjectLines, { 'no': projectNo , 'task_no': lineNo});
      if (projectLine) {
        return projectLine.description;
      } else {
        return;
      }
    },
    moment: function (date) {
      return moment(date).format('DD/MM/YYYY');
    },
    approveRegistration: function(registration) {
      const now = moment().format();
      const userid = JSON.parse(localStorage.getItem('profile')).user_id;

      this.$firebaseRefs.regs.child(registration['.key']).update({approverUID: userid, isApproved: true, timestampApproval: now})
      //push approvals to upload
      // const updates = {
      //   date: registration['date'],
      //   project: registration['project'],
      //   projectLine: registration['projectLine'],
      //   uid: registration['uid'],
      //   tenantid: registration['tenantid'],
      //   time: registration['time'],
      //   timestamp: now,
      //   timestampOrignialRegistration: registration['timestamp']
      // };
      const postingDate = moment().startOf('day').format('YYYY-MM-DD[T]HH:mm:ss[Z]');
      const documentDate = moment(registration['date']).startOf('day').format('YYYY-MM-DD[T]HH:mm:ss[Z]'); //2018-07-03T00:00:00Z
      // FIXME: resNo
      const updates = {
        description: 'Tidsregistrering',
        docNo: 'test tid',
        extDocNo: registration['.key'],
        jobNo: registration['project'],
        jobTaskNo: registration['projectLine'],
        quantity: registration['time'],
        req: 'post',
        resNo: 'JE',
        type: 'JobJournal',
        postingDate: postingDate,
        documentDate: documentDate
      }
      // push approval to ERP queue
      this.$firebaseRefs.regsERP.child(registration['.key']).update(updates)
    },
    rejectRegistration: function(regKey) {
      const updates = {sentForApproval: false, isApproved: false, isRejected: true}
      this.$firebaseRefs.regs.child(regKey).update(updates)
    },
    approveAbsence: function(registration) {
      const userid = JSON.parse(localStorage.getItem('profile')).user_id;
      const now = moment().format();
      this.$firebaseRefs.absence.child(registration['.key']).update({approverUID: userid, isApproved: true, timestampApproval: now})
      //push approvals to upload
      // const updates = {
      //   fromDate: registration['fromDate'],
      //   toDate: registration['toDate'],
      //   absence: registration['absence'],
      //   absenceMeasure: registration['absenceMeasure'],
      //   upn: registration['upn'],
      //   uid: registration['uid'],
      //   time: registration['time'],
      //   timestamp: now,
      //   timestampOrignialRegistration: registration['timestamp']
      // };
      // this.$firebaseRefs.absenceERP.child(registration['.key']).update(updates)
    },
    rejectAbsence: function(registration) {
      const updates = {sentForApproval: false, isApproved: false, isRejected: true}
      this.$firebaseRefs.absence.child(registration['.key']).update(updates)
    },
  }
}
</script>
<style scoped>
</style>
